import { render, staticRenderFns } from "./ForGetPassword.vue?vue&type=template&id=489f60cc&scoped=true&"
import script from "./ForGetPassword.vue?vue&type=script&lang=ts&"
export * from "./ForGetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f60cc",
  null
  
)

export default component.exports